module.exports = __webpack_public_path__ + "img/586win.83f27a0d.png";